// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"936e28f4","445":"936e28f4","911":"0f02dc65"}[chunkId] + ".chunk.css";
};